// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b581df5","453":"60a3b7a8","455":"3384b9c9"}[chunkId] + ".chunk.js";
};